/**
 * 交易中心
 */
import {
    QUOTE_WS_URL,
    PRODUCT_LIST,
  } from '../mutation-type';

  const state = { 
qouteWsUrl: '',
      productList: [], 
...(localStorage.getItem('ehammer.state') ? JSON.parse(localStorage.getItem('ehammer.state')).trade:{}) 
};

  const mutations = {
    [QUOTE_WS_URL]: (s, qouteWsUrl) => {
      s.qouteWsUrl = qouteWsUrl;
    },
    [PRODUCT_LIST]: (s, productList) => {
      s.productList = productList;
    },
  };
  export default {
    state,
    mutations,
  };
